module.exports = __webpack_public_path__ + "img/icon_upload_file.9dc42217.svg";